import { InlineChildren } from '@doordash/design-language'
import styled from 'styled-components'

export const MIN_WIDTH = 128

export const HorizontalContainer = styled(InlineChildren).attrs({
  size: InlineChildren.Sizes.XxSmall,
})`
  & > *:first-child {
    flex-shrink: 1;
    min-width: ${MIN_WIDTH}px;
  }
  & > *:last-child {
    flex-shrink: 1;
    min-width: ${MIN_WIDTH}px;
  }
`
